<template>
	<v-card
		v-bind="$attrs"
	>
		<v-card-title class="d-flex align-center">
			<v-img
				class="ma-1"
				max-height="24"
				max-width="24"
				location="start"
				src="/frontoffice/images/brand/icons/icon-228.png"
			/>
			<strong>{{ complete ? "Mobile Complete" : "Mobile Essential" }}</strong>
		</v-card-title>
		<v-card-subtitle
			v-if="deviceName"
			class="ml-8"
		>
			{{ deviceName }}
		</v-card-subtitle>
		<v-card-text>
			<v-row>
				<v-col>
					<v-list
						density="compact"
						class="ma-0 pa-0"
					>
						<v-list-item
							v-for="(item, i) in complete ? completeList : essentialList"
							:key="i"
							class="ma-0 pa-0"
							density="compact"
						>
							<template #prepend>
								<v-icon
									class="ma-0 pa-0"
									:icon="item.icon"
									color="primary"
								/>
							</template>
							<v-list-item-subtitle class="ma-0 pa-0">
								{{ item.text }}
							</v-list-item-subtitle>
						</v-list-item>
					</v-list>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<div
						class="mr-2 pa-0 text-primary"
					>
						<translate>Monthly terminable</translate>
					</div>
				</v-col>
			</v-row>
			<v-row v-if="!price">
				<v-col>
					<span><translate>Unavailable for the selected device</translate></span>
				</v-col>
			</v-row>
			<div v-else>
				<v-row>
					<v-col>
						<span><translate>First 3 months for</translate> <strong><translate>free</translate></strong>, {{ deviceName ? $gettext('thereafter') : $gettext('thereafter from') }}</span>
					</v-col>
				</v-row>
				<v-row no-gutters>
					<v-col>
						<span class="mr-2 text-h6 font-weight-bold text-secondary">{{ Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR'}).format(price) }}</span>
						<translate>Per month</translate>
					</v-col>
				</v-row>
			</div>
		</v-card-text>
		<v-card-actions
			v-if="!readonly"
			class="justify-center ml-2 mr-2"
			style="padding-bottom: 25px"
		>
			<v-btn
				:disabled="deviceName === null"
				color="secondary"
				variant="elevated"
				block
				rounded
				elevation="0"
				@click="$emit('selected')"
			>
				<translate>
					Insure
				</translate>
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
export default {
	name: 'ProductCard',
	props: {
		complete: {
			type: Boolean,
			default: false
		},

		price: {
			type: Number,
			default: null,
		},

		readonly: {
			type: Boolean,
			default: true,
		},

		deviceName: {
			type: String,
			default: null
		}
	},

	emits: ['selected',],

	computed: {
		essentialList () {
			return [
				{
					text: this.$gettext('Water damage'),
					icon: '$checkBold'
				},
				{
					text: this.$gettext('Impact / fall damage'),
					icon: '$checkBold'
				},
				{
					text: this.$gettext('Safely insured'),
					icon: '$checkBold'
				},
				{
					text: '',
					icon: ''
				},
				{
					text: '',
					icon: ''
				},
			];
		},

		completeList () {
			return [
				{
					text: this.$gettext('Water damage'),
					icon: '$checkBold'
				},
				{
					text: this.$gettext('Impact / fall damage'),
					icon: '$checkBold'
				},
				{
					text: this.$gettext('Theft'),
					icon: '$checkBold'
				},
				{
					text: this.$gettext('Costs of use after theft'),
					icon: '$checkBold'
				},
				{
					text: this.$gettext('Safely insured'),
					icon: '$checkBold'
				},
			];
		},
	}
};
</script>

<style scoped>

</style>
